/**
 * Itemized price breakdown for the booking panel. The availability API returns
 * a PER-UNIT price (qty is never passed to resolveBookingPrice), so the grand
 * total multiplies by qty here — the customer-facing half of the multi-unit
 * pricing fix. Pure.
 */
import { formatCents } from '@sifly/shared-utils'

export type PriceBreakdownInput = {
  perUnitTotalCents: number // resolveBookingPrice totalCents (one unit, all days)
  perDayCents: number
  days: number
  qty: number
}
type PriceLine = { label: string; amountCents: number }
export type PriceBreakdown = { lines: PriceLine[]; grandTotalCents: number }

export function priceBreakdown(input: PriceBreakdownInput): PriceBreakdown {
  const { perUnitTotalCents, perDayCents, days, qty } = input
  const dayWord = days === 1 ? 'day' : 'days'
  const lines: PriceLine[] = [
    { label: `${formatCents(perDayCents)} × ${days} ${dayWord}`, amountCents: perUnitTotalCents },
  ]
  const grandTotalCents = perUnitTotalCents * qty
  if (qty > 1) {
    lines.push({ label: `× ${qty} boards`, amountCents: grandTotalCents })
  }
  return { lines, grandTotalCents }
}
